import React from 'react'

export default function CollaborationTimeline() {
  return (
    <div className="bg-white dark:bg-rb-dark-mode rounded-2xl border border-dashed border-rb-widget-border dark:border-rb-dark-mode-lighter p-8 text-center text-sm text-rb-lighter-grey dark:text-gray-400">
      Collaboration timeline view is coming soon.
    </div>
  )
}

